/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2PatientRemoveIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2PatientRemoveIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2PatientRemoveIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 20,
  height = 20,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#7B8794"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2PatientRemoveIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 20 20"
 style={{'--as-1-Ziq49z': alignSelf,'--mt-2-Ziq49z': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Ziq49z': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Ziq49z': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Ziq49z': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Ziq49z': opacity,'--w-10-Ziq49z': typeof width === 'number' ? `${width}px` : width,'--h-11-Ziq49z': typeof height === 'number' ? `${height}px` : height,'--f-12-Ziq49z': fill,'--a-7-Ziq49z': isAnimated ? animation : "none",'--sd-8-Ziq49z': isAnimated ? strokeDashoffset : 0,'--sd-9-Ziq49z': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2PatientRemoveIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M11 6a3 3 0 11-6 0 3 3 0 016 0zm5.78 6.54a.75.75 0 10-1.06-1.06l-1.59 1.59-1.59-1.59a.75.75 0 10-1.06 1.06l1.59 1.59-1.59 1.59a.75.75 0 101.06 1.06l1.59-1.59 1.59 1.59a.75.75 0 101.06-1.06l-1.59-1.59 1.59-1.59zM8 10a5 5 0 00-5 5 .5.5 0 00.5.5h6.655c.098-.242.245-.468.44-.664l.707-.706-.706-.706a2 2 0 01-.079-2.745A4.977 4.977 0 008 10z"
 style={{'--f-12-Ziq49z': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}